import type { Identifier } from 'dnd-core';
import { DndType } from '~/_shared/constants/dndType.enum';
import {
  type ColumnRole, CONTACT_COLUMNS_ROLES,
} from '~/_shared/types/columnRole.enum';

export const getItemDnDType = (type?: ColumnRole | null) => {
  if (!type) {
    return DndType.LocalizationBasicItem;
  }

  return CONTACT_COLUMNS_ROLES.includes(type) ? DndType.LocalizationContactItem : DndType.LocalizationBasicItem;
};

export const areDnDTypesEqual = (type1: Identifier | null, type2: DndType) => type1 === type2;
